import { AloAccompagnementLg } from "./AloAccompagnementLg"
import { AloBase, getDefaultAloBase } from "./AloBase"


export interface AloAccompagnement extends AloBase  {    
    lgs:Array<AloAccompagnementLg>
}

export const getDefaultAloAccompagnement = ():AloAccompagnement => {
    return {
        ...getDefaultAloBase(),
        lgs:[]
    }
}